var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1651_140713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1651_140713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73268 15.5L4.46602 13.3667L2.06602 12.8333L2.29935 10.3667L0.666016 8.5L2.29935 6.63333L2.06602 4.16667L4.46602 3.63333L5.73268 1.5L7.99935 2.46667L10.266 1.5L11.5327 3.63333L13.9327 4.16667L13.6994 6.63333L15.3327 8.5L13.6994 10.3667L13.9327 12.8333L11.5327 13.3667L10.266 15.5L7.99935 14.5333L5.73268 15.5ZM7.29935 10.8667L11.066 7.1L10.1327 6.13333L7.29935 8.96667L5.86602 7.56667L4.93268 8.5L7.29935 10.8667Z",
    fill: "#3F25AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCheckmark);
export default __webpack_public_path__ + "static/media/verified-checkmark.712750920d76c6438b29a8f63f335790.svg";
export { ForwardRef as ReactComponent };